/**
 * @file_purpose  page created for game list page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 13-03-2024
 */

import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { listGame, resetListGame } from '../../redux/slices/GameSlice';
import { FormattedMessage } from "react-intl";
import Games from './Games';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';

const GameList = ({ categoryId, isMainPage = false }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const userDetailState = useSelector((state) => state.userDetailState);
    let gameState = useSelector((state) => state.gameState);


    const languageState = useSelector((state) => state.languageState);
    let languageCode = languageState.active_language.language_code;

    let category_id = location?.state?.category_id ? location?.state?.category_id : categoryId;
    let category_name = location?.state?.category_name ? location?.state?.category_name : "Demo";

    let location_pathname = location?.pathname ? location?.pathname : "";

    let provider_id = location?.state?.provider_id || null;
    let provider_name = location?.state?.provider_name || null;

    const accountList = useSelector((state) => state.accountState.account_list);
    const loginCreds = useSelector((state) => state.authState.logincreds);
    let token = userDetailState?.user_details?.token || "";

    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedImportAccount, setSelectedImportAccount] = useState("");
    const [importing, setImporting] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const [state, setState] = useState({
        game_name: ""
    })

    const providerAccounts = accountList?.filter(acc => acc.provider_id === provider_id || acc.provider === provider_id) || [];
    const displayAccounts = loginCreds?.account_id
        ? (accountList || []).filter(acc => acc._id === loginCreds.account_id)
        : (providerAccounts.length > 0 ? providerAccounts : (accountList || []));

    const handleImportGames = async () => {
        if (!selectedImportAccount) {
            toast.error("Please select an account first.", { position: "bottom-right" });
            return;
        }

        setImporting(true);
        const params = JSON.stringify({
            provider_id: provider_id,
            account_id: selectedImportAccount
        });

        GeneralService.apiPostCallRequest(ApiURL.importGames, params, token)
            .then(res => {
                setImporting(false);
                if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Import Successful',
                        text: res.message || 'Games imported successfully!',
                    });
                    setShowImportModal(false);
                    // Refresh Games component
                    setRefreshTrigger(prev => prev + 1);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Import Failed',
                        text: res.message || 'Failed to import games.',
                    });
                }
            })
            .catch(err => {
                setImporting(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Import Failed',
                    text: err.message || 'An error occurred during import.',
                });
            });
    };

    const [useCommonCallback, setUseCommonCallback] = useState(() => {
        return localStorage.getItem('useCommonCallback') === 'true';
    });

    useEffect(() => {
        localStorage.setItem('useCommonCallback', useCommonCallback);
    }, [useCommonCallback])

    useEffect(() => {

        dispatch(resetListGame())

    }, [location?.pathname])

    const handleChange = (e) => {
        const { id, value } = e.target;
        dispatch(resetListGame())
        setState(prevState => ({
            ...prevState,
            [id]: value
        }))
    }

    return (
        <div className='container'>
            <div className='provider-heading-section'>
                <span>{provider_name != null ? `${provider_name} : ${category_name[[languageCode]]}` : `${category_name[[languageCode]]}`}</span>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {provider_id && (
                        <button className='import-game-button' onClick={() => {
                            setSelectedImportAccount(loginCreds?.account_id || "");
                            setShowImportModal(true);
                        }}>
                            <i className="fa-solid fa-cloud-arrow-down me-2"></i> Import Games
                        </button>
                    )}
                    <Link to="/"><button className='back-button'>
                        <i className="fa-solid fa-arrow-left me-2"></i> <FormattedMessage id='BACK' />
                    </button></Link>
                </div>
            </div>
            <div className='provider-detail-page-section'>
                <div className='search_filter_section'>
                    <div className='provider-filter-section'>
                        {provider_id && (
                            <Link to="/provider-list">
                                <button className='view-all-providers' style={{ marginRight: "10px" }}>
                                    <FormattedMessage id='VIEWALLPROVIDERS' />
                                </button>
                            </Link>
                        )}
                    </div>
                    {provider_id && ['Evolution', 'Red Tiger', 'NetEnt', 'Big Time Gaming', 'Nolimit City - 94', 'Nolimit City - 96', 'Tap-A-Roo', 'Nolimit City - 92', 'Nolimit City'].includes(provider_name) && (
                        <div className='common-callback-toggle'>
                            <label className='toggle-label'>
                                <input
                                    type='checkbox'
                                    checked={useCommonCallback}
                                    onChange={(e) => setUseCommonCallback(e.target.checked)}
                                />
                                <span className='toggle-slider'></span>
                                <span className='toggle-text'>Common Callback</span>
                            </label>
                        </div>
                    )}
                    <div className="game_search_sec" >
                        <i className="fa-solid fa-magnifying-glass" />
                        <input type="search" id='game_name' name='game_name' placeholder={languageCode == "en" ? "Search your game" : "게임 검색"} value={state.game_name} onChange={handleChange} />
                    </div>
                </div>

                <Games category_id={category_id} game_name={state.game_name} provider_id={provider_id} provider_name={provider_name} useCommonCallback={useCommonCallback} refreshTrigger={refreshTrigger} />

            </div>

            <Modal
                show={showImportModal}
                onHide={() => !importing && setShowImportModal(false)}
                backdrop="static"
                centered
            >
                <div className="apply_comp_sec">
                    {importing && (
                        <div className="launch-overlay" style={{ background: 'rgba(0,0,0,0.5)', borderRadius: '15px', position: 'absolute' }}>
                            <div className="launch-spinner"></div>
                            <span className="launch-text">Importing games...</span>
                        </div>
                    )}
                    <Modal.Header closeButton={!importing} className='py-3'>
                        <h6 className="hed_txt m-0">Import Games - {provider_name}</h6>
                    </Modal.Header>

                    <div className="p-4">
                        <div className="row login-register-form">
                            <div className="col-md-12 input-display">
                                <label htmlFor="import_account">
                                    Select Provider Account
                                    <span className='v-error'> * </span>
                                </label>
                                <select
                                    id='import_account'
                                    name='import_account'
                                    value={selectedImportAccount}
                                    onChange={(e) => setSelectedImportAccount(e.target.value)}
                                    disabled={importing || !!loginCreds?.account_id}
                                >
                                    <option value="">Select Account</option>
                                    {displayAccounts.map((item, keyIndex) => (
                                        <option key={keyIndex} value={item._id}>
                                            {item.account_name} ({item.currency_support})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-4">
                        <div className="col-md-10 offset-md-1 save-cancel-btn">
                            <button
                                className="save_btn"
                                style={{ marginRight: 10 }}
                                onClick={handleImportGames}
                                disabled={importing}
                            >
                                Import
                            </button>
                            <button
                                className="cancel_btn"
                                onClick={() => setShowImportModal(false)}
                                disabled={importing}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Common Callback Toggle Styles */}
            <style>${`
            .search_filter_section {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
            }
            
            .provider-filter-section {
                display: flex;
                align-items: center;
            }
            
            .common-callback-toggle {
                display: flex;
                align-items: center;
                flex: 1;
                justify-content: center;
            }

            .toggle-label {
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                font-size: 14px;
                color: #fff;
            }

            .toggle-label input[type="checkbox"] {
                display: none;
            }

            .toggle-slider {
                position: relative;
                width: 44px;
                height: 24px;
                background-color: #ccc;
                border-radius: 34px;
                transition: background-color 0.3s;
            }

            .toggle-slider:before {
                position: absolute;
                content: "";
                height: 18px;
                width: 18px;
                left: 3px;
                bottom: 3px;
                background-color: white;
                border-radius: 50%;
                transition: transform 0.3s;
            }

            .toggle-label input:checked + .toggle-slider {
                background-color: #28a745;
            }

            .toggle-label input:checked + .toggle-slider:before {
                transform: translateX(20px);
            }

            .toggle-text {
                font-weight: 500;
            }

            .view-all-providers {
                cursor: pointer;
                border: 2px solid #5f6d93;
                outline: none;
                background-color: transparent;
                color: #fff;
                border-radius: 20px;
                padding: 5px 15px;
            }

            .game_search_sec {
                width: 30%;
                background: #091126;
                border: 3px solid #384771;
                border-radius: 25px;
                position: relative;
            }

            .game_search_sec i {
                position: absolute;
                left: 20px;
                top: 12px;
                color: #5f6d93;
            }

            .game_search_sec input {
                width: 100%;
                background: none;
                border: none;
                padding: 4px 15px 7px 42px;
                color: #5f6d93;
                outline: none;
            }

            .game_search_sec input:focus {
                outline: none;
                box-shadow: none;
            }

            .game_search_sec input::placeholder {
                color: #5f6d93;
            }

            .import-game-button {
                cursor: pointer;
                border: 2px solid #5f6d93;
                outline: none;
                background-color: transparent;
                color: #fff;
                border-radius: 20px;
                padding: 5px 15px;
                font-weight: 500;
                font-size: 15px;
                transition: all 0.3s ease;
            }

            .import-game-button:hover {
                background-color: #5f6d93;
                border-color: #5f6d93;
            }
        `}</style>
        </div>
    )
}

export default GameList
